<mat-card class="credit-logs-card">
    <mat-card-title class="credit-logs-title">
        <h2>Credit Logs</h2>
        @if (dialogRef) {
            <button mat-icon-button type="button" aria-label="Close credit logs" (click)="dialogRef.close()">
                <mat-icon>close</mat-icon>
            </button>
        }
    </mat-card-title>
    <mat-card-subtitle>Credits added or charged, not GBP. Pin charges use the work category and policy at the time. Follow-up histories, edits, defect completion and sign-off are included. Subscription-included usage adds no PAYG debit.</mat-card-subtitle>

    @if (users?.length > 0 && transactionTypes?.length > 0 &&
    transactionOrigins?.length > 0) {
    <form class="form" [formGroup]="creditLogsFilter">
        <mat-expansion-panel style="margin-bottom: 1em;">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <mat-icon>filter_alt</mat-icon> Filter
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row">
                <div class="col-md-3">
                    <mat-form-field>
                        <mat-label>Credits</mat-label>
                        <input
                            matInput
                            type="number"
                            formControlName="amount"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field>
                        <mat-label>Change Type</mat-label>
                        <mat-select
                            formControlName="transaction_origins"
                            multiple
                        >
                            @for (origin of transactionOrigins; track origin) {
                            <mat-option [value]="origin.id">{{
                                origin.title | titlecase
                            }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field>
                        <mat-label>Transaction Type</mat-label>
                        <mat-select
                            formControlName="transaction_types"
                            multiple
                        >
                            @for (type of transactionTypes; track type) {
                            <mat-option [value]="type.id">{{
                                type.title | titlecase
                            }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field>
                        <mat-label>Actioned By</mat-label>
                        <mat-select formControlName="authors" multiple>
                            @for (user of users; track user) {
                            <mat-option [value]="user.id">{{
                                user.value
                            }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <mat-action-row>
                <button
                    mat-stroked-button
                    (click)="creditLogsFilter.reset(); loadCreditLogs()"
                >
                    Clear
                </button>
                <button
                    mat-flat-button
                    color="primary"
                    (click)="currentPage = 0; loadCreditLogs()"
                >
                    <mat-icon>search</mat-icon> Search
                </button>
            </mat-action-row>
        </mat-expansion-panel>
    </form>
    }

    <mat-card-content>
        <table mat-table [dataSource]="credit_logs" class="w-100">
            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef>Credits</th>
                <td mat-cell *matCellDef="let credit_log">
                    {{ credit_log?.amount | number: "" }}
                </td>
            </ng-container>

            <ng-container matColumnDef="change_type">
                <th mat-header-cell *matHeaderCellDef>Change Type</th>
                <td mat-cell *matCellDef="let credit_log">
                    {{ credit_log?.origin?.title | titlecase }}
                </td>
            </ng-container>

            <ng-container matColumnDef="transaction_type">
                <th mat-header-cell *matHeaderCellDef>Transaction Type</th>
                <td mat-cell *matCellDef="let credit_log">
                    {{ credit_log?.type?.title | titlecase }}
                </td>
            </ng-container>

            <ng-container matColumnDef="actioned_by">
                <th mat-header-cell *matHeaderCellDef>Actioned By</th>
                <td mat-cell *matCellDef="let credit_log">
                    {{ credit_log?.author?.name | titlecase }}
                </td>
            </ng-container>

            <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef>Created At</th>
                <td mat-cell *matCellDef="let credit_log">
                    {{ credit_log?.created_at | date: "d/MM/yyyy  h:mma" }}
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" style="text-align: center;" colspan="999">
                    No credit logs were found...
                </td>
            </tr>
        </table>

        <mat-paginator
            [length]="totalRows"
            [pageIndex]="currentPage"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            (page)="pageChanged($event)"
            aria-label="Select page"
            showFirstLastButtons
        >
        </mat-paginator>
    </mat-card-content>
</mat-card>
